import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { isFunction } from 'lodash';
import React, { useEffect, useState } from 'react';
import { ensuredForwardRef } from 'react-use';
import KskTooltip from '../KskPopover/KskTooltip';
import { makeid } from 'utils/stringUtils';
import { faChevronUp, faChevronDown, faAngleDoubleUp, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

//import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
//import { faUpRightAndDownLeftFromCenter, faDownLeftAndUpRightToCenter } from '@fortawesome/free-solid-svg-icons';

const KskCollapseControlStyled = styled.div`
  .ksk-collapse__buttons {
    display: flex;
    gap: 0.25em;
    margin-left: auto;
    padding-right: 8px;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  & {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .ksk-collapse__button--collapse-all,
  .ksk-collapse__button--expand-all {
    border-radius: 50% !important;
    width: 1.5em !important;
    height: 1.5em !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    margin: 0 !important;
    vertical-align: top !important;
        
    mask-image: none !important;
    -webkit-mask-image: none !important;
    
    .ksk-collapse__button__icon {
      mask-image: none !important;
      -webkit-mask-image: none !important;
      background: transparent !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      filter: none !important;
      box-shadow: none !important;
      margin: 0 !important;
    }
    
    &:hover {
      background: #f0f0f0 !important;
      border-color: rgba(0,0,0,0.2) !important;
    }
    
    &:active {
      background: #e0e0e0 !important;
      transform: scale(0.95);
    }
  }

  .ksk-collapse__button--default {
    background-color: transparent !important;
    mask-image: none !important;
    -webkit-mask-image: none !important;
    border: 1px solid transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: #1351B4 !important;
    cursor: pointer !important;
    padding: 4px !important;
    border-radius: 4px !important;

  }
`;


const KskCollapseButtonStyled = styled.div`

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: center !important;

  .ksk-collapse__button--default {
    padding: 4px !important;
    border-radius: 50% !important;

    &:hover {
      background: #f0f0f0 !important;
      border-color: rgba(0,0,0,0.2) !important;
    }

    &:active {
      background-color: rgba(19, 81, 180, 0.2) !important;
      transform: scale(0.95);
    }
  }
`;


const handlerCollapseControl = (e, action) => {
  e.stopPropagation();
  //const parentElement = document.querySelector(`#${id}`);
  const parentElement = e.currentTarget.closest('.ksk-collapse--control');

  if (parentElement == null) {
    return;
  }





  const children = parentElement.querySelectorAll?.("details:not(.keep-closed)");
  const keepClosed = parentElement.querySelectorAll?.(".keep-closed");

  if (action === 'collapseAll') {
    children.forEach((item) => item.removeAttribute("open"));
    keepClosed.forEach((item) => item.removeAttribute("open"));
  } else {
    [parentElement, ...children].forEach((item) => item.setAttribute("open", true));
  }
};

export const KskCollapseControl = () => {
  return (
    <KskCollapseControlStyled>
      <div className="ksk-collapse__buttons">
        <KskTooltip title="Recolher tudo" arrow>
          <button type="button"
            className="ksk-collapse__button ksk-collapse__button--collapse-all"
            onClick={(e) => handlerCollapseControl(e, 'collapseAll')}>
            <span className="ksk-collapse__button__icon ksk-collapse__button__icon--with-drop-shadow">
              {/* <FontAwesomeIcon icon={faMinusSquareRegular} /> */}
              <FontAwesomeIcon icon={faAngleDoubleUp} />
            </span>
          </button>
        </KskTooltip>

        <KskTooltip title="Expandir tudo" arrow>
          <button type="button"
            className="ksk-collapse__button ksk-collapse__button--expand-all"
            onClick={(e) => handlerCollapseControl(e, 'expandAll')}>
            <span className="ksk-collapse__button__icon  ksk-collapse__button__icon--with-drop-shadow">
              {/* <FontAwesomeIcon icon={faPlusSquareRegular} /> */}
              <FontAwesomeIcon icon={faAngleDoubleDown} />
            </span>
          </button>
        </KskTooltip>
      </div>
    </KskCollapseControlStyled>
  );
}

const KskBoxCollapse = ensuredForwardRef(({ id, borders, className, title, renderTitle, children, onToggle, initialOpen = true, collapseControl = false, keepClosed = false, disabled = false }, ref) => {
  const summaryId = `ksk-collapse-${makeid(8)}`;
  const [isOpen, setIsOpen] = useState(initialOpen);
  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!disabled) {
      setIsOpen(true);
    }
  }, [disabled]);

  const handleSummaryKeyDown = React.useCallback((e) => {
    if (!disabled) {
      return;
    }

    if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
      e.preventDefault();
      e.stopPropagation();
    }
  }, [disabled]);

  const handleSummaryClick = React.useCallback((e) => {
    if (!disabled) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
  }, [disabled]);

  return (
    <>
      <details open={disabled ? false : isOpen} id={id} ref={ref}
        style={{
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.6 : 1,
        }}
        className={[
          className,
          'ksk-collapse',
          classNames({
            'ksk-collapse--with-borders': !!borders,
            'ksk-collapse--control': collapseControl,
            'keep-closed': keepClosed,
          })].join(' ').trim()
        }
        onToggle={(e) => {
          if (e.target !== e.currentTarget) {
            return;
          }
          setIsOpen(e.target.open);
          isFunction(onToggle) && onToggle(e);
        }}
      >
        <summary
          id={summaryId}
          tabIndex={disabled ? -1 : 0}
          aria-disabled={disabled}
          className={[
            'ksk-collapse__summary',
            classNames({
              'ksk-collapse__summary--open': isOpen,
              'ksk-collapse__summary--closed': !isOpen,
              'ksk-collapse__summary--control': collapseControl,
            })].join(' ').trim()
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}
          onClick={handleSummaryClick}
          onKeyDown={handleSummaryKeyDown}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {renderTitle ? (
              <>
                {renderTitle()}
                <span className='title-and-rendertitle'>{title}</span>
              </>
            ) : (
              <span className='text-up-01 mb-1'>{title}</span>
            )}
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
            <KskCollapseButtonStyled>

              <KskTooltip title={'Expandir / Recolher conteúdo'} arrow>
                <div role="button" className="ksk-collapse__button ksk-collapse__button--default">
                  <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                </div>
              </KskTooltip>
            </KskCollapseButtonStyled>

            {collapseControl && <KskCollapseControl />}
          </div>
        </summary>

        <div className="ksk-collapse__content">
          {children}
        </div>
      </details>
    </>
  )
})

export default KskBoxCollapse;
